'use client';

import {
  VideoBase,
  VideoContent,
  VideoDate,
  VideoDescription,
  VideoPlayer,
  VideoThumbnail,
  VideoTitle,
} from '@/app_components/Video/Video';
import { VideoThumbnailStn } from '@/app_components/Video/VideoThumbnailStn';
import { useHideDateStamp } from '@/app_lib/hooks/useHideDateStamp';
import type { AdTags } from '@/app_lib/services/ads/defaults';
import type { Video } from '@/app_lib/types/Video';

interface VideoDefaultProps {
  modal?: boolean;
  orientation?: 'horizontal' | 'vertical';
  showDescription?: boolean;
  target?: string;
  watching?: boolean;
  video: Video;
  className?: string;
  'data-index'?: number;
  playing?: boolean;
  adTags?: AdTags[];
  hideDateStamp?: boolean;
  videoType?: 'stn' | 'vod';
}

export const VideoDefault = ({
  watching = false,
  modal = false,
  orientation,
  showDescription = false,
  target,
  video,
  className,
  adTags,
  playing = false,
  hideDateStamp,
  videoType = 'stn',
  'data-index': index,
}: VideoDefaultProps) => {
  const hideDateFromExperiment = useHideDateStamp();
  const hideDate = hideDateStamp || hideDateFromExperiment;
  const VideoThumbnailComponent = videoType === 'stn' ? VideoThumbnailStn : VideoThumbnail;

  return (
    <VideoBase
      className={className}
      dataCy='video-card'
      modal={modal}
      orientation={orientation}
    >
      {playing ? (
        <VideoPlayer
          adTags={adTags}
          dataCy='video-player'
          layout='default'
          modal={modal}
          orientation='vertical'
          target={target}
          videoId={video.id}
        />
      ) : (
        <VideoThumbnailComponent
          className={target}
          data-index={index}
          duration={video.duration}
          modal={modal}
          orientation={orientation}
          src={video.thumbnail}
          watching={watching}
        />
      )}
      <VideoContent
        modal={modal}
        orientation={orientation}
      >
        <VideoTitle
          className={target}
          data-index={index}
          modal={modal}
          orientation={orientation}
          playing={playing}
          title={video.title}
          watching={watching}
        />
        {showDescription && (
          <VideoDescription
            description={video.summary}
            modal={modal}
            orientation={orientation}
          />
        )}
        <VideoDate
          date={video.age}
          hidden={hideDate}
          modal={modal}
          orientation={orientation}
        />
      </VideoContent>
    </VideoBase>
  );
};
